import React from "react";
import SectionLink from "./SectionLink.jsx";
import { IoFastFoodOutline } from "react-icons/io5";
import { TbRosetteDiscountCheck } from "react-icons/tb";
const TablesGroup = () => {
  return (
    <div className="flex flex-col gap-y-2">
      <SectionLink
        icon={IoFastFoodOutline}
        title={"Productos"}
        link={"/products"}
      />
    </div>
  );
};

export default TablesGroup;
